import Upload from './Upload';
import Dragger from './Dragger';
Upload.Dragger = Dragger;
export default Upload;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/upload/index.js
// module id = 1769
// module chunks = 0